import { observer } from 'mobx-react';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { currentUserStore } from '../CurrentUserStore';

class Logout extends React.Component {
  componentDidMount() {
    currentUserStore.logout();
  }

  render() {
    return <Navigate to="/logged-out" />;
  }
}

export default observer(Logout);
